import { Alert, Button } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const RetryErrorAlert = ({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) => {
  const { t } = useTenantTranslation();
  return (
    <Alert
      severity="error"
      action={<Button onClick={onRetry}>{t("retry")}</Button>}
    >
      {message}
    </Alert>
  );
};
